<template>
  <router-view />
</template>
<script>
export default {
  name: 'TencentAdvertising',
  data() {
    return {

    }
  },
  created() {
    const route = this.$route.matched.find(item => item.name === 'TencentAdvertising')
    this.$store.dispatch('tagsView/addCachedView', route)
  }
}
</script>
